<script>
const VARIANT_ICONS = {
  info: 'fe-info',
  warn: 'fe-alert-triangle',
  success: 'fe-check-circle',
  error: 'fe-x-circle',
};

export default {
  props: {
    variant: {
      type: String,
      default: 'info',
      validator: v => ['info', 'warn', 'success', 'error'].includes(v),
    },
    icon: { type: String, default: null },
  },
  computed: {
    resolvedIcon() {
      return this.icon || VARIANT_ICONS[this.variant];
    },
  },
};
</script>

<template>
  <div :class="['app-notice', 'app-notice--' + variant]">
    <i :class="resolvedIcon"></i>
    <span><slot></slot></span>
  </div>
</template>
